import type { ShipMethod } from './api'

/**
 * Выбор на оформлении, который переживает уход на страницы адреса и аптеки:
 * экран оформления там размонтируется, а вернуться покупатель должен туда же —
 * к тому же способу получения и той же аптеке. В браузер не пишем: это выбор
 * одного оформления, а не настройка.
 */
let ship: ShipMethod | null = null
let storeId = 0

export function draftShip(): ShipMethod | null {
  return ship
}

export function draftStore(): number {
  return storeId
}

export function rememberShip(next: ShipMethod): void {
  ship = next
}

export function rememberStore(next: number): void {
  storeId = next
}

/** Заказ ушёл — следующее оформление начинается с чистого листа. */
export function resetDraft(): void {
  ship = null
  storeId = 0
}
